import { TextField } from 'material-ui';
import React, { useEffect, useState } from 'react';
import { displayValue } from './common';
import helpers from 'helpers';

export default function General({
    cargoPacking,
    disabledAll,
    modifyFields,
    errors,
}) {
    const [_errors, set_errors] = useState(errors);

    useEffect(() => {
        set_errors(errors);
    }, [errors]);

    return (
        <React.Fragment>
            <div 
                className='row'
                style={{ width: '100%', height: '92px' }}
            >
                <div className='col-xs-3'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.temperatureMin', disabledAll,
                            )
                        }
                        hintText='Temperature min, °C'
                        floatingLabelText='Temperature min, °C'
                        disabled={disabledAll}
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '0px 5px',
                        }}
                        onChange={e => modifyFields([{
                            field: 'packing.pack.temperatureMin', 
                            value: helpers.clearLetters(e.target.value),
                        }])}
                    />
                </div>
                <div className='col-xs-3_flex'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.temperatureMax', disabledAll,
                            )
                        }
                        errorText={_errors.temperatureMax && _errors.temperatureMax.messages[0]}
                        hintText='Temperature max, °C'
                        floatingLabelText='Temperature max, °C'
                        disabled={disabledAll}
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '15px',
                        }}
                        onChange={e => modifyFields([{
                            field: 'packing.pack.temperatureMax', 
                            value: helpers.clearLetters(e.target.value),
                        }])}
                    />
                </div>
                <div className='col-xs-3'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.moistureMin', disabledAll,
                            )
                        }
                        hintText='Moisture min, %'
                        floatingLabelText='Moisture min, %'
                        disabled={disabledAll}
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '15px',
                        }}
                        onChange={e => modifyFields([{
                            field: 'packing.pack.moistureMin', 
                            value: helpers.clearLetters(e.target.value),
                        }])}
                    />
                </div>
                <div className='col-xs-3_flex'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.moistureMax', disabledAll,
                            )
                        }
                        errorText={_errors.moistureMax && _errors.moistureMax.messages[0]}
                        hintText='Moisture max, %'
                        floatingLabelText='Moisture max, %'
                        disabled={disabledAll}
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '0px 5px',
                        }}
                        onChange={e => modifyFields([{
                            field: 'packing.pack.moistureMax', 
                            value: helpers.clearLetters(e.target.value),
                        }])}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/General.jsx